export default "__VITE_ASSET__CpWVce9R__"